import { APIData, appFetch } from ".";

export interface Certificate {
  id: number;
  name: string;
  image: string;
  logo: string;
}

export const certificatesApi = {
  fetchPage(page: number) {
    return appFetch<APIData<Certificate[]>>("/certificates?page=" + page)
  },
};
